<h3 class="ai-coach">
  <span class="label">AI Coach</span>
  <span class="flag-beta" *ngIf="isBeta">BETA</span>
</h3>
